export enum DEVICE_MODE {
    INPUT,
    TIMER,
    TERMOSTAT,
    HYDROSTAT
}